/**
 * Singleton für globale Eigenschaften zur AGT 4-Gas Tester Kalibrierung
 */

import { action, observable } from 'mobx';

import { provideSingleton } from '../utils/decorators';
import { IObjektVorlage } from '../models/ApiTypes';
import { KalibrierungStore } from './KalibrierungStore';

@provideSingleton(Agt4GasKalibrierungStore)
export class Agt4GasKalibrierungStore extends KalibrierungStore {

  @observable messunsicherheitAnwenden: boolean = false;
  @observable objektVorlage: IObjektVorlage | undefined = undefined;
  @observable justage: boolean = false;
  @observable genauigkeitsklasseUeberschreiben: boolean = false;

  @action setMessunsicherheitAnwenden(value: boolean) {
    this.messunsicherheitAnwenden = value;
  }

  @action setObjektVorlage(value: IObjektVorlage | undefined) {
    this.objektVorlage = value;
  }

  @action setJustage(value: boolean) {
    this.justage = value;
  }

  @action setGenauigkeitsklasseUeberschreiben(value: boolean) {
    this.genauigkeitsklasseUeberschreiben = value;
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/stores/Agt4GasKalibrierungStore.ts